import { useSelector } from 'react-redux'
import { Route } from 'react-router-dom'
import { NoMatchAndRefresh } from './no-match-and-refresh'

const routeAccess = {
  '/admin': {
    role: ['account_owner', 'manager', 'standard_user'],
    permissions: [],
  },
  '/admin/settings': {
    role: ['account_owner', 'manager', 'standard_user'],
    permissions: [],
  },
  '/admin/users': {
    role: ['account_owner'],
    permissions: ['all_privileges', 'manage_users'],
  },
  '/admin/activities': {
    role: ['account_owner'],
    permissions: ['all_privileges'],
  },
  '/admin/groups': {
    role: ['account_owner'],
    permissions: ['all_privileges', 'manage_groups'],
  },
  '/admin/accounts': {
    role: ['account_owner'],
    permissions: ['all_privileges', 'manage_connectors'],
  },
  '/admin/connectors': {
    role: ['account_owner'],
    permissions: ['all_privileges', 'manage_connectors'],
  },
  '/admin/accounts/create-update': {
    role: ['account_owner'],
    permissions: ['all_privileges', 'manage_connectors'],
  },
  '/admin/targets/multi-target': {
    role: ['account_owner'],
    permissions: ['all_privileges', 'manage_targets'],
  },
  '/admin/targets': {
    role: ['account_owner'],
    permissions: ['all_privileges', 'manage_targets'],
  },
  '/admin/patterns/:id': {
    role: ['account_owner'],
    permissions: ['all_privileges', 'manage_patterns'],
  },
  '/admin/patterns': {
    role: ['account_owner'],
    permissions: ['all_privileges', 'manage_patterns'],
  },
  '/admin/targets/:targetId': {
    role: ['account_owner'],
    permissions: ['all_privileges', 'manage_targets'],
  },
  '/admin/fieldsets': {
    role: ['account_owner'],
    permissions: ['all_privileges', 'manage_field_sets'],
  },
  '/admin/fieldsets/:fieldSetId/fields': {
    role: ['account_owner'],
    permissions: ['all_privileges', 'manage_field_sets'],
  },
  '/admin/fieldsets/create-update': {
    role: ['account_owner'],
    permissions: ['all_privileges', 'manage_field_sets'],
  },
  '/admin/lists': {
    role: ['account_owner'],
    permissions: ['all_privileges', 'manage_lists'],
  },
  '/admin/lists/edit/:id': {
    role: ['account_owner'],
    permissions: ['all_privileges', 'manage_lists'],
  },
  '/admin/lists-manager': {
    role: ['account_owner'],
    permissions: ['all_privileges', 'manage_lists'],
  },
  '/admin/lists-manager/edit/:id': {
    role: ['account_owner'],
    permissions: ['all_privileges', 'manage_lists'],
  },
  '/admin/lists-manager/new': {
    role: ['account_owner'],
    permissions: ['all_privileges', 'manage_lists'],
  },
  '/admin/templates': {
    role: ['account_owner'],
    permissions: ['all_privileges', 'manage_templates'],
  },
  '/admin/templates/edit-template/:id': {
    role: ['account_owner'],
    permissions: ['all_privileges', 'manage_templates'],
  },
  '/admin/folders': {
    role: ['account_owner'],
    permissions: ['all_privileges', 'manage_folders'],
  },
  '/admin/folders/create-update': {
    role: ['account_owner'],
    permissions: ['all_privileges', 'manage_folders'],
  },
  '/admin/csv/': {
    role: ['account_owner'],
    permissions: ['all_privileges'],
  },
  '/admin/csv/manage': {
    role: ['account_owner'],
    permissions: ['all_privileges'],
  },
  '/admin/account/reports': {
    role: ['account_owner'],
    permissions: ['all_privileges', 'access_reports'],
  },
  '/admin/account/settings': {
    role: ['account_owner', 'manager'],
    permissions: ['manage_account_settings'],
  },
  '/admin/taxonomy-translation': {
    role: ['account_owner'],
    permissions: ['all_privileges'],
  },
  '/admin/taxonomy-translation/create': {
    role: ['account_owner'],
    permissions: ['all_privileges'],
  },
  '/dashboard': {
    role: ['account_owner'],
    permissions: ['all_privileges'],
  },
  '/settings/account/general': {
    role: ['account_owner'],
    permissions: [],
  },
  '/template/:id': {
    role: ['account_owner'],
    permissions: [],
  },
  '/template/:id/selective': {
    role: ['account_owner'],
    permissions: [],
  },
}

export const PermissionedRoute = ({ component: Component, ...rest }) => {
  const features = useSelector(state => state.Auth.features)
  const rowLevelPermissionsEnabled = Boolean(features?.['row-level-permissions'])
  const role = useSelector(state => state.Auth.user.role)
  let access = useSelector(state => {
    let allowed = false
    routeAccess[rest.path] &&
      routeAccess[rest.path].permissions.forEach(permission => {
        if (state.Auth.permissions[permission]) {
          allowed = true
        }
      })
    return allowed
  })

  if (rowLevelPermissionsEnabled) {
    const templateIdRoute = routeAccess['/template/:id']
    const editIdRoute = routeAccess['/template/:id/selective']

    templateIdRoute.role.push('manager', 'standard_user')
    editIdRoute.role.push('manager', 'standard_user')
  }

  access = access || (routeAccess[rest.path] && routeAccess[rest.path].role.includes(role))
  return (
    <Route
      {...rest}
      render={props => (access ? <Component {...props} /> : <NoMatchAndRefresh />)}
    />
  )
}
